module.exports = "<span [innerHtml]=\"fileContent\" *ngIf=\"fileContent\"></span>\r\n"